import EtatErreur from '../../components/EtatErreur';
import Text from '../../components/Text';
import { useDashboardKPIs } from '../../../api/dashboard/useDashboardKPIs';
import { echecSansDonnee } from '../../helpers/requete';
import { langueMobile, t } from '../../i18n/langue';

import { Carte, Indicateur } from './briques';

/**
 * Les rendus des modules portés — #22, #87.
 *
 * Alimentés par les hooks de `pages/dashboard/api/`, qui convergent (#23 autorise
 * `api/`) ; seuls les RENDUS sont réécrits ici.
 */

const nombre = (n: number | undefined) => new Intl.NumberFormat(langueMobile()).format(n ?? 0);

/**
 * `kpis` — les quatre indicateurs réels de `DashboardKPIs`.
 *
 * ⚠️ Masqué en scope groupe par `MODULES_MASQUES_EN_GROUPE` : il dérive des
 * réservations, et « Arrivées aujourd'hui : 0 » se lirait comme une mesure.
 */
export function ModuleIndicateurs() {
    const { data, isLoading, isError, refetch } = useDashboardKPIs();
    const k = data?.data;
    // Un refetch en échec garde `data` (react-query 3) : les indicateurs valides
    // restent affichés, l'échec ne se dit que sans aucune donnée (relecture I1).
    const echec = echecSansDonnee({ isError, data });

    return (
        <Carte titre={t('dashboard.indicateurs.titre')}>
            {echec ? (
                <EtatErreur onReessayer={() => void refetch()} />
            ) : isLoading ? (
                <Text variante="petit" ton="attenue">
                    {t('commun.chargement')}
                </Text>
            ) : (
                <div className="grid grid-cols-2 gap-2">
                    <Indicateur valeur={nombre(k?.arrivals_today)} libelle={t('dashboard.indicateurs.arrivees')} />
                    <Indicateur
                        valeur={nombre(k?.guests_on_site)}
                        libelle={t('dashboard.indicateurs.surPlace')}
                        dessous={k?.occupancy_rate !== undefined ? t('dashboard.indicateurs.occupation', { taux: Math.round(k.occupancy_rate) }) : undefined}
                    />
                    <Indicateur valeur={nombre(k?.communications_total_30d)} libelle={t('dashboard.indicateurs.communications')} />
                    <Indicateur
                        valeur={`${nombre(k?.marketing_revenue_30d)} €`}
                        libelle={t('dashboard.indicateurs.revenuMarketing')}
                    />
                </div>
            )}
        </Carte>
    );
}
